import React from "react"
import { Card, CardMedia, CardActions, Typography } from "@material-ui/core/"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import adImage from "../../assets/images/ad_mockup_image.png"
// import cmImage from "../../assets/images/cm_mockup_image.png"
import fiveSixImage from "../../assets/images/five_six_logo.png"
import a2pImage from "../../assets/images/a2p.jpeg"
import claryCommImage from "../../assets/images/clary.jpg"
import newClaryCommImage from "../../assets/images/newClaryImage.png"
import ipgImage from "../../assets/images/ipglogo.png"
import millsJamesImage from "../../assets/images/MillsJamesAdCard.png"
import accordImage from "../../assets/images/accordAdCard.png"
import { getCurrentHost } from "../../utils/getHost"

const AdCard = ({ classes, ad, adIndex }) => {
  // var currentIndex = images.length,
  //   temporaryValue,
  //   randomIndex
  console.log(ad.name)
  const imgURL =
    ad.name === "ipg"
      ? "https://immanuelproductiongroup.com/"
      : ad.name === "fivesix"
        ? "https://www.fivesix.com/"
        : ad.name === "a2p"
          ? "https://www.august2productions.com/"
          : ad.name === "clary"
            ? "https://www.clarycomm.net/"
            : ad.name === "millsjames"
              ? "https://www.millsjames.com/"
              : " https://accordproductions.com/"
  const imgTitle =
    ad.name === "ipg"
      ? "All Things Media From Conception To Completion"
      : ad.name === "fivesix"
        ? "Las Vegas Video Production"
        : ad.name === "a2p"
          ? "Global/National Production: produce@august2productions.com"
          : ad.name === "clary"
            ? "New Wave Provider Of Live Event Managed Services For Events Across The Country"
            : ad.name === "millsjames"
              ? "Video | Events | Creative"
              : "We have a roome for you!"
  const img =
    ad.name === "ipg"
      ? ipgImage
      : ad.name === "fivesix"
        ? fiveSixImage
        : ad.name === "a2p"
          ? a2pImage
          : ad.name === "clary"
            ? newClaryCommImage
            : ad.name === "millsjames"
              ? millsJamesImage
              : accordImage
  return (
    <Card
      className={classes.card}
      onClick={() => {
        var win = window.open(imgURL, "_blank")
        win.focus()
      }}
    >
      <CardMedia component="img" height="140" image={img} title={imgTitle} />
      <CardActions className={classes.sponsored}>
        <Typography variant="body2" color="textSecondary" component="p">
          Sponsored
        </Typography>
      </CardActions>
    </Card>
  )
}

export default withStyles(styles, { withTheme: true })(AdCard)
